export default {
  addPoint(state, data) {
    state.game.points.push(data.point);
    state.game.labels.push(data.label);
    // すべてのプロパティに対して実施する
    Object.keys(state.game.manualLabels).forEach((key) => {
      if (state.game.points.length - state.game.manualLabels[key].value.length === 1) {
        state.game.manualLabels[key].value.push(0);
      }
    });
    if (state.game.isProMode) {
      state.game.hitsList[state.game.points.length - 1] = data.hits;
    }
  },
  addGameInfo(state, data) {
    const key = data.key;
    const value = data.value;
    state.game.gameInfo[key] = value;
  },
  delPoint(state) {
    state.game.points.pop();
    state.game.labels.pop();
    // すべてのプロパティに対して実施する
    Object.keys(state.game.manualLabels).forEach((key) => {
      // manualLabels追加後にbackした場合も含め、points配列と長さが合うようにする
      while (state.game.manualLabels[key].value.length > state.game.points.length) {
        state.game.manualLabels[key].value.pop();
      }
    });
    if (state.game.isProMode) {
      const tmp = Object.assign({}, state.game.hitsList);
      delete tmp[state.game.points.length];
      state.game.hitsList = tmp;
    }
  },
  addManualLabel(state, obj) {
    const tmp = Object.assign({}, state.game.manualLabels);
    tmp[obj.name] = obj;
    state.game.manualLabels = tmp;
    // ゲーム途中で追加した場合の対応
    while (state.game.points.length > state.game.manualLabels[obj.name].value.length) {
      state.game.manualLabels[obj.name].value.push(0);
    }
  },
  delManualLabel(state, obj) {
    const tmp = Object.assign({}, state.game.manualLabels);
    delete tmp[obj.name];
    state.game.manualLabels = tmp;
  },
  addManualArray(state, obj) {
    // 変更を反映させるために、コピーを作成してから再代入する
    const tmp = Object.assign({}, state.game.manualLabels);
    // points配列と比較して、追加するかどうかの判定を実施する
    if (state.game.points.length === tmp[obj.name].value.length) {
      tmp[obj.name].value.push(obj.p);
      state.game.manualLabels = tmp;
    }
  },
  popManualArray(state, obj) {
    state.game.manualLabels[obj.name].value.pop();
  },
  setGameData(state, obj) {
    state.game = obj.data;
    state.app.docId = obj.docId;
  },
  setGameDataOption(state, obj) {
    state.game = { ...obj.game, hitsList: obj.option };
    state.app.docId = obj.docId;
  },
  SignIn(state, obj) {
    state.user = { signIn: true, uid: obj.uid };
  },
  setRedirect(state, obj) {
    state.user.redirect = obj;
  },
  SignOut(state) {
    state.user.signIn = false;
    state.user.uid = '';
  },
  storeIsLoading(state, obj) {
    state.app.loading = obj;
  },
  setMessage(state, obj) {
    state.app.message = obj;
  },
  reset(state, obj) {
    state.game = {
      points: [],
      labels: [],
      manualLabels: {},
      hitsList: {},
      gameInfo: {
        matchCnt: 3,
        matchName: '練習試合',
        player1Name: '選手1',
        player2Name: '選手2',
        player1Game: 0,
        player2Game: 0,
        firstGameServer: 0, // 0 or 1 or 2
        isRealTime: false,
        linkShareFlg: false,
        publicShareFlg: false,
        memoFlg: false,
        memo: '',
      },
      status: 10,
      createDate: undefined,
      updateDate: undefined,
      isProMode: obj.isProMode,
    };
    state.app.docId = undefined;
  },
  delGameData(state) {
    state.game.status = 90;
    state.game.gameInfo.publicShareFlg = false;
    state.game.gameInfo.linkShareFlg = false;
  },
  linkShareFlgOn(state, obj) {
    state.game.gameInfo.linkShareFlg = obj;
  },
  publicShareFlgOn(state, obj) {
    state.game.gameInfo.publicShareFlg = obj;
  },
  updHits(state, obj) {
    state.game.hitsList[obj.pointIdx].hand.splice(obj.hitIdx, 1, obj.hit.hand);
    state.game.hitsList[obj.pointIdx].hitStyle.splice(obj.hitIdx, 1, obj.hit.hitStyle);
    state.game.hitsList[obj.pointIdx].hitPosition.splice(obj.hitIdx, 1, obj.hit.hitPosition);
    state.game.hitsList[obj.pointIdx].course.splice(obj.hitIdx, 1, obj.hit.course);
    state.game.hitsList[obj.pointIdx].inOutDetail.splice(obj.hitIdx, 1, obj.hit.inOutDetail);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js